module.exports = __webpack_public_path__ + "img/ring_y_0_0_1@2x.a56cceb6.png";